<template>

	<div class="dummy_pie_chart_container">
	 	<div class="dummy-pie-chart">

	 		<div class="msg_layer">Coming Soon</div>

	 		<div class="top_layer"></div>

	 		<div class="icon-barGraph"></div>

	 		<div class="btm_layer"></div>

			<div class="graph-container">

				<div class="bars">
					<span class="bar_container">
						<span class="bar bar1"></span>
					</span>
					<span class="bar_container">
						<span class="bar bar2"></span>
					</span>
					<span class="bar_container">
						<span class="bar bar3"></span>
					</span>
					<span class="bar_container">
						<span class="bar bar4"></span>
					</span>
					<span class="bar_container">
						<span class="bar bar5"></span>
					</span>
			  	</div>

				<div class="graph-x">
					<span class="value">0-39</span>
					<span class="value">40-64</span>
					<span class="value">65-79</span>
					<span class="value">80-89</span>
					<span class="value">90-100</span>
			  	</div>

			  	<div class="graph-y">
					<span class="start-value value">0</span>
					<span class="end-value value">1</span>
			  	</div>

			  	<div class="title-axis-y"># of y axis</div>


			  	<div class="data">

			  	</div>

			</div>
		</div>

		<div class="pie_chart_name ace_sec_txt" aria-label="Activity">Activity</div>

	</div>

</template>

<script>
  import '../../../assets/module/css/dashboard/dummyGraph.min.css'

  export default {
    name: 'dummy-graph',
    data: () => {
      return {
      }
    }
  }
</script>


<style scoped>


</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/dummyGraph.vue